import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCompassPointerSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCompassPointerSquare"><Path d="M20.5 3.5L3.5 3.5L3.5 20.5L20.5 20.5L20.5 3.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M8.25 15.8583L12 8.1416L15.75 15.8583L12 14.5583L8.25 15.8583Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconCompassPointerSquare;
